import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Lightning } from "@phosphor-icons/react";

const PRO_PERKS = [
  "Unlimited Paid Duty entries",
  "Email forwarding + AI extraction",
  "Charts, analytics & full reports",
  "PDF / Excel / CSV exports",
  "Email notifications & cloud backup",
];

export default function UpgradeModal() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      setMessage(e.detail || "This feature requires DutyTrack Pro.");
      setOpen(true);
    };
    window.addEventListener("pro-required", handler);
    return () => window.removeEventListener("pro-required", handler);
  }, []);

  const goUpgrade = () => {
    setOpen(false);
    navigate("/settings/billing");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="h-11 w-11 rounded-xl bg-primary/15 flex items-center justify-center mb-2">
            <Crown className="h-6 w-6 text-primary" weight="fill" />
          </div>
          <DialogTitle className="text-xl font-black">This feature requires Pro</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground" data-testid="upgrade-modal-message">
            {message}
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 my-2">
          {PRO_PERKS.map((p) => (
            <li key={p} className="flex items-center gap-2 text-sm">
              <Lightning className="h-4 w-4 text-primary shrink-0" weight="fill" /> {p}
            </li>
          ))}
        </ul>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="upgrade-modal-dismiss" className="flex-1 rounded-md">
            Maybe later
          </Button>
          <Button onClick={goUpgrade} data-testid="upgrade-modal-cta" className="flex-1 rounded-md font-semibold">
            <Crown className="h-4 w-4 mr-1.5" weight="fill" /> Upgrade to Pro
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
